<template>
  <div class="row">
    <div class="col-4 mt-3">
      <div>
        <strong>{{ name }}</strong>
      </div>
    </div>
    <div class="col-8 mt-3">
      <div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BatchFormField',
  props: [
    'name'
  ],
  data() {
    return {

    };
  },
};
</script>
